export class Tenant {
    Text: string;
    Value: string;
    TenantId: string;
    PassportApiUrl: string;
    PassportApiKey: string;
    ProvisionedApplications: string[];
    GraphEndpoint: string;
    HasAccess: boolean;
    RestrictTenant: boolean;
    TenantStatus: string | null;
    LicenceId: string;
    TenantPermissionGroup: string;
    CrmId: string | null;
    CrmName: string | null;
    Industry: string;
    Size: string;
    ProvisionedAsTrial: boolean;
    BestPracticeTenant: boolean;
}

export interface IRule {
    Id: number;
    Description: string;
    OperationType: string;
    Conditions: ICondition[];
    InstructionType: number;
    Instructions: IInstruction[];
    IsActive: boolean;
    IsValid: boolean;
}

export interface ICondition {
    $type: string;
    Operator: number;
    Value: string;
    ValueArray: string[];
    ParentName: string;
    MultiItemName: string;
    PropertyName: string;
    PropertyType: string;
}

export interface IConditionField {
    type: string;
    ParentName: string;
    MultiItemName: string;
    PropertyName: string;
    PropertyType: string;
}

export interface IInstruction {
    TO: string;
    TEMPLATE_ID: string;
    SUBJECT: string;
}
